import type { RouteDef } from '@cobliteam/dashboard/src/dashboardDef.type';
import type { FeatureFlags } from '@cobliteam/hooks/src/useFeatureFlags';

const FEATURE_FLAG_KEYS_WITH_FALSE: (keyof FeatureFlags)[] = ['disableWifiConfiguration']; // :warning: This is a hack to make the sidebar work with the feature flag

const getRoutesWithPermissionAndFeatureFlag = (routesDef: RouteDef[], featureFlags: FeatureFlags) => {
  const isVisible = (featureFlag?: keyof FeatureFlags) => {
    if (featureFlag === undefined) return true;

    if (FEATURE_FLAG_KEYS_WITH_FALSE.includes(featureFlag)) {
      return featureFlags[featureFlag] === false;
    }
    return featureFlags[featureFlag] === true;
  };
  const routesDefWithFeatureFlag = routesDef.reduce<RouteDef[]>((acc, route) => {
    if (!isVisible(route?.featureFlag)) return acc;

    const routesWithFeatureFlag = route.routes?.filter((subRoute) => {
      subRoute.routes = subRoute.routes?.filter((group) => isVisible(group?.featureFlag));
      return isVisible(subRoute.featureFlag);
    });

    if (routesWithFeatureFlag?.length) {
      acc.push({ ...route, routes: routesWithFeatureFlag });
      return acc;
    }

    if (isVisible(route?.featureFlag)) acc.push(route);

    return acc;
  }, []);
  return routesDefWithFeatureFlag;
};

export default getRoutesWithPermissionAndFeatureFlag;
